<template>
	<div>
		<GenericSelector
			:value="normalizedValue"
			@input="val => handleInput(val)"
			:options="options"
			:selectedWrapperClass="selectedWrapperClass"
            :selectedItemClass="selectedItemClass"
            :optionWrapperClass="optionWrapperClass"
            :optionItemClass="optionItemClass"
			:selectorStyle="selectorStyle"
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="!rooms"
			:displayCb="displayCb"
			:displayKey="displayKey"
		>
			<template v-if="label" v-slot:selectedHeader>
				<strong>{{ label }}</strong>
			</template>
			<template v-slot:unselectedHeader>
				<div class="d-flex flex-row align-items-center justify-content-between my-2" style="gap: 4px">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" />

					<button
						type="button"
						@click="showOptions = !showOptions"
						class="btn btn-secondary ml-auto"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: {
		GenericSelector,
		SearchBar,
	},
    props: {
		value: [Array, Object],
		rooms: Array,
		loading: {
			type: Boolean,
			default: false,
		},
		displayCb: {
			type: Function,
			default: room => room.name,
		},
		label: String,
		displayKey: String,
        // Over-ride the class used to wrap the selected list
        selectedWrapperClass: {
            type: String,
            default: 'list-group border-radius-2 no-border',
        },
        // Over-ride the class used to wrap the selected item
        selectedItemClass: {
            type: String,
            default: 'list-group-item',
        },
        // Over-ride the class used to wrap the option list
        optionWrapperClass: {
            type: String,
            default: 'list-group border-radius-2 no-border',
        },
        // Over-ride the class used to wrap the option items
        optionItemClass: {
            type: String,
            default: 'list-group-item',
        },
        // Choose from a handful of default presentation styles for this item
        // "list": this is the default style
        // "tag": this present as a "tag" style input selector
        // "none": this removes all styles so you can create your own using slots
        selectorStyle: {
            type: String,
            default: 'list',
        },
         // Limits room selection
         limit: {
            type: Number
        }
	},
    data() {
        return {
            showOptions: false,
			search: '',
        };
    },
    methods:{
        handleInput(selectedItems) {
            let output = this.limit === 1 
                ? selectedItems[selectedItems.length - 1] || null 
                : selectedItems
            
            this.$emit('input', output)
        }
    },
    computed: {
        normalizedValue() {
            if (this.limit === 1) {
                return this.value ? [this.value] : []
            }
            return Array.isArray(this.value) ? this.value : []
        },
		options() {
			return this.rooms.filter(room => !this.search
				|| room.name && room.name.toLowerCase().includes(this.search.toLowerCase())
			)
		}
    },
};
</script>
